import src from "IMAGE";
export default { src, width: 208, height: 40, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAM0lEQVR42i3KMQoAIAwEwXuZnbUWgqJWVub/H8gGUgwc3ErSwsPMPdBRYFDLI4KLjYOP6quKBXHU7Ch6AAAAAElFTkSuQmCC"};
